/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  ControlLabel,
  FormGroup,
  Pagination,
  Tooltip,
} from "react-bootstrap";
import {
  searchReport,
  deleteMedication,
  GetPackages,
  is_package_featured_status_change,
  getCity,
  searchMedication,
  AddMedicationbulkfile,
  exportmedicationfile,
  DeleteReport,
  GetDepartment,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";
import LoadingSpinner from "views/Components/loadingSpinner";

import SweetAlert from "react-bootstrap-sweetalert";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";

import Card from "components/Card/Card.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
class reportlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      medication_detail: [],
      report_detail: [],
      package_details: [],
      category_name: "",
      itemcode: "",
      title: "",
      Dept_details: [],
      medicationcategory: "",
      price: "",
      commision: "",
      unitprice: "",
      tat: "",
      tags: "",
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      package: "",
      loading: false,
      tabledata: [],
      page: "",
      _notificationSystem: null,
      alert: null,
      useraccess: "",
      medicationfile: null,
      city: "0",
      showbulkui: 0,
      noRecordFound: false,
      is_featured: "",
      city_info: [],
      report_type: "",
    };
    this.fileInput = React.createRef();

    this.selectedreport = this.selectedreport.bind(this);
    this.deletereport = this.deletereport.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.searchData = this.searchData.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.addbulkmedication = this.addbulkmedication.bind(this);
    // this.onChange = this.onChange.bind(this);

    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
  }
  selectedreport(cus) {
    // console.log(cus);
    localStorage.setItem("reportID", JSON.stringify(cus));

    this.props.history.push("/admin/editreport");
  }
  async componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    this.searchData();
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    this.setState({
      useraccess: token.role,
    });

    let compelte = 1;
    let pg_no = 1;
    while (compelte == 1) {
      await GetPackages(obj, pg_no)
        .then((res) => {
          const cat_data = res.data;
          if (cat_data.data.length == 0) {
            compelte = 0;
          } else {
            var array1 = this.state.package_details;
            var array2 = array1.concat(cat_data.data);
            this.setState({
              package_details: array2,
              category_name: cat_data.category_name,
            });
          }
        })
        .catch((error) => {
          compelte = 0;
          console.log(error, "== error");
          this.handleNetworkError("bl", error);
        });
      pg_no++;
    }

    GetDepartment(obj)
      .then((res) => {
        this.setState({ Dept_details: res.data });
      })
      .catch((error) => {
        this.handleNetworkError("bl", error);
        console.log(error, "== error");
      });
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
    if (name == "unitprice") {
      var val = parseFloat(value);
      this.setState({ unitprice: val });
    }

    setTimeout(() => this.searchdata(), 200);
  };

  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }

  searchdata(e) {
    this.setState({ page: "" });
    this.searchData();
  }

  resetSearch(e) {
    this.setState({
      itemcode: "",
      title: "",
      package: "0",
      price: "",
      commision: "",
      unitprice: "",
      city: "0",
      tat: "",
      tags: "",
      is_featured: "",
      report_type: "",
    });
    this.searchData();
  }

  subStrAfterChars(str, char, pos) {
    if (pos == "b") return str.substring(str.indexOf(char) + 1);
    else if (pos == "a") return str.substring(0, str.indexOf(char));
    else return str;
  }
  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ noRecordFound: false });

    this.setState({ loading: true }, () => {
      searchReport(
        this.state.itemcode,
        this.state.title,
        this.state.price,
        this.state.package,
        this.state.unitprice,
        this.state.page,
        this.state.tat,
        this.state.tags,
        this.state.is_featured,
        this.state.report_type,
        obj,
      )
        .then((response1) => {
          var data = response1.data;
          var report = data.data;
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          var $no_pages = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
              });
            } else {
              this.setState({
                nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
              });
            } else {
              this.setState({
                prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }
          this.setState({ paginationData: $no_pages });

          this.setState({
            loading: false,
            tabledata: data.data,
            report_detail: report,
          });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl", error);
        });
    });
  }
  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deletereport(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Report Detail !
        </SweetAlert>
      ),
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  addbulkmedication() {
    this.setState({
      showbulkui: 1,
    });
  }
  closemedicatonupload() {
    this.setState({
      showbulkui: 0,
    });
  }
  exportfile() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    exportmedicationfile(obj).then((res) => {});
  }
  is_feature_change(id, feature) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var is_featured = "";
    if (feature == "1") {
      is_featured = 0;
    } else if (feature == "0") {
      is_featured = 1;
    }
    is_package_featured_status_change(is_featured, id, obj)
      .then((res) => {
        if (res.data.success == true) {
          this.searchData();
        } else {
          this.handleClick("bl");
        }
      })
      .catch((error) => {
        this.handleNetworkError("bl", error);
      });
  }

  deletereport(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;

    DeleteReport(id, obj)
      .then(() => {
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl", error);
      });
  }
  addreport() {
    this.props.history.push("/admin/addreport");
  }

  render() {
    const change_status = (
      <Tooltip id="change_status">Change Feature Status</Tooltip>
    );
    const view = <Tooltip id="view">View Profile</Tooltip>;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const medication_detail = this.state.medication_detail;
    const report_data = this.state.tabledata;
    const package_details = this.state.package_details;
    const city_info = this.state.city_info;
    // console.log(medication_detail);
    // const medication_category_detail =  medication.map(med=>{
    //   med.medication_category.map(cat=>{
    //    <td> {cat.category_name}</td>
    //   })
    // })
    // console.log(medication_category_detail)
    var c = 1;
    // console.log(medication);
    // const medicationcat = category.map((cat)=>{
    //   {cat.id}
    //   // ':' ;{cat.catgory_name}
    // })
    const add_Commisson_array = { 1: "Yes", 0: "No" };

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <div style={{ padding: "0 28px" }}>
                    {this.state.useraccess == 4 ||
                    this.state.useraccess == 6 ||
                    this.state.useraccess == 7 ||
                    this.state.useraccess == 8 ||
                    this.state.useraccess == 9 ||
                    this.state.useraccess == 10 ? (
                      ""
                    ) : (
                      <Row className="text-right">
                        <Button
                          className="fl_mb_web_1 btn-fill fl_mb_1 w_150 "
                          class="btn-color" //bsStyle="info" fill
                          onClick={this.addreport.bind(this)}
                        >
                          Report <i className="fa fa-plus"></i>
                        </Button>
                        <br />
                        &nbsp;
                        {/* <Button  className="fl_mb_web_1 btn-fill fl_mb_1 w_150 " onClick={this.addbulkmedication.bind(this)}  bsStyle="info" fill  >Add Bulk Medication</Button> */}
                        {/* {this.state.showbulkui == 1 ? 
                    <Col xs={12} sm={12} md={12} lg={12} > 
                    <h5>Upload Medication details</h5>
                    <form>
                      <FormGroup>
                      <ControlLabel>Bulk Medication</ControlLabel>
                      <input type="file"  name="medicationfile" onChange={this.handleInputChange}  placeholder="select file" />
                      </FormGroup>
                      <FormGroup>
                        <Button fill onClick={this.submitbulkmedication.bind(this)} bsStyle="success">Submit</Button>
                        &nbsp;
                        <Button fill  onClick={this.closemedicatonupload.bind(this)} bsStyle="danger">close</Button>
                        &nbsp;
                        <Button fill  onClick={this.exportfile.bind(this)} bsStyle="danger">export</Button>
                        
                      </FormGroup>
                    </form>
                    </Col>
                    : ''} */}
                      </Row>
                    )}

                    <Row
                      className="OrderList_fill"
                      style={{
                        borderRadius: "5px",
                        padding: "10px",
                      }}
                    >
                      <Col md={3} sm={6}>
                        <FormControl
                          name="itemcode"
                          value={this.state.itemcode || ""}
                          placeholder="Report Code"
                          onChange={this.onChange}
                          type="text"
                          style={{ margin: 0, marginBottom: 10 }}
                        />
                      </Col>
                      <Col md={3} sm={6}>
                        <FormControl
                          name="title"
                          value={this.state.title || ""}
                          placeholder="title"
                          onChange={this.onChange}
                          type="text"
                          style={{ margin: 0, marginBottom: 10 }}
                        />
                      </Col>
                      <Col md={3} sm={6}>
                        <select
                          className="form-control"
                          name="package"
                          value={this.state.package || ""}
                          onChange={this.onChange}
                          type="select"
                          style={{ margin: 0, marginBottom: 10 }}
                        >
                          <option value="">Select Package</option>
                          {package_details.map((cat) => (
                            <option value={cat.id}>{cat.package_name}</option>
                          ))}
                        </select>
                        {/* <FormControl  name="medicationcategory" value={this.state.medicationcategory ||''} placeholder="Medicationcategory" onChange={this.onChange} type="text" /> */}
                      </Col>
                      <Col md={3} sm={6}>
                        <FormControl
                          name="unitprice"
                          value={this.state.unitprice || ""}
                          placeholder="Unit Price"
                          onChange={this.onChange}
                          type="text"
                          style={{ margin: 0, marginBottom: 10 }}
                        />
                      </Col>
                      <Col md={3} sm={6} className="fl_mb_1">
                        <select
                          name="is_featured"
                          placeholder="is_featured"
                          value={this.state.is_featured || ""}
                          onChange={this.onChange}
                          className="form-control"
                        >
                          <option value="">Is Featured</option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </select>
                      </Col>
                      <Col md={3} sm={6} className="fl_mb_1">
                        <select
                          name="report_type"
                          placeholder="report_type"
                          value={this.state.report_type || ""}
                          onChange={this.onChange}
                          className="form-control"
                        >
                          <option value="">Report Type</option>
                          <option value="homecare">HomeCare</option>
                          <option value="lab">Lab</option>
                        </select>
                      </Col>
                      <Col md={6} sm={6}>
                        <Button
                          class="btn-color" //bsStyle="info"
                          fill
                          onClick={this.searchdata.bind(this)}
                        >
                          Filter
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                          class="btn-color" //bsStyle="info"
                          fill
                          onClick={this.resetSearch.bind(this)}
                        >
                          Reset
                        </Button>
                      </Col>
                    </Row>

                    <Row xs={12} sm={12} md={12} lg={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Report Code</th>
                            <th> Report Title</th>
                            <th>Package</th>
                            <th>Price</th>
                            <th>Unit Price</th>
                            <th>Department</th>
                            <th>report Type</th>
                            <th>Parent Test</th>
                            <th>Feature</th>
                            <th>TAT</th>
                            <th>Tags</th>

                            {/* <th>Description</th> */}
                            {this.state.useraccess == 3 ? (
                              ""
                            ) : (
                              <th className="text-right">Actions</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colspan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {report_data.map((cus) => (
                                <tr>
                                  <td>{cus.test_code}</td>
                                  <td>{cus.title}</td>
                                  <td>
                                    {this.state.package_details.map((pc) => (
                                      <>
                                        {cus.report_packages.map((re) => (
                                          <>
                                            {pc.id == re.id
                                              ? pc.package_name + ","
                                              : ""}
                                          </>
                                        ))}
                                      </>
                                    ))}
                                  </td>
                                  <td>{(cus.price - 0).toFixed(2)}</td>

                                  <td>{(cus.unit_price - 0).toFixed(2)}</td>
                                  <td>
                                    {this.state.Dept_details.map((de) => (
                                      <>
                                        {de.id == cus.department_id
                                          ? de.department_name
                                          : ""}
                                      </>
                                    ))}
                                  </td>
                                  <td style={{ textTransform: "capitalize" }}>
                                    {cus.report_type}
                                  </td>
                                  <td>
                                    {cus.parent_test != null
                                      ? cus.parent_test
                                      : "-"}
                                  </td>
                                  <td>
                                    {cus.is_featured == "0" ? "No" : "Yes"}
                                  </td>
                                  <td>
                                    {cus.parent_test != null
                                      ? cus.parent_test
                                      : "-"}
                                  </td>
                                  <td>
                                    {cus.parent_test != null
                                      ? cus.parent_test
                                      : "-"}
                                  </td>
                                  {/* <td>{cus.description != "" ? cus.description : '-'}</td> */}
                                  {this.state.useraccess == 3 ? (
                                    ""
                                  ) : (
                                    <td className="td-actions text-right no-padding">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={change_status}
                                      >
                                        <Button
                                          simple
                                          bsStyle="info"
                                          onClick={this.is_feature_change.bind(
                                            this,
                                            cus.id,
                                            cus.is_featured,
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-check-square-o" />
                                        </Button>
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.selectedreport.bind(
                                            this,
                                            cus.id,
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-edit" />
                                        </Button>
                                      </OverlayTrigger>
                                      {this.state.useraccess == 1 && (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={remove}
                                        >
                                          <Button
                                            simple
                                            bsStyle="danger"
                                            onClick={this.warningWithConfirmAndCancelMessage.bind(
                                              this,
                                              cus.id,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-times" />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </React.Fragment>
                          )}
                        </tbody>
                      </Table>
                      {this.state.loading ? (
                        ""
                      ) : this.state.noRecordFound ? (
                        ""
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <Pagination>
                            <Pagination.First
                              dataUrl={this.state.prevpage}
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.prevpage,
                              )}
                              disabled={this.state.prevdisabled}
                            />
                            {this.state.paginationData.map((url) => (
                              <Pagination.Item
                                dataUrl={url}
                                active={
                                  this.state.currentPage == c ? "1" : null
                                }
                                onClick={this.paginationinfo.bind(this, url)}
                              >
                                {c++}
                              </Pagination.Item>
                            ))}
                            <Pagination.Last
                              dataUrl={this.state.nextpage}
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.nextpage,
                              )}
                              disabled={this.state.nextdisabled}
                            />
                          </Pagination>
                        </div>
                      )}
                    </Row>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(reportlist);
